import { Pipe, PipeTransform } from '@angular/core';
import { formatCreditorType } from '../_helpers/enum-label.helper';
import { CreditorType } from '../enum/creditortype.enum';

@Pipe({
    name: 'creditorTypeLabel',
    standalone: false
})
export class CreditorTypeLabelPipe implements PipeTransform {
  transform(value: CreditorType | number | null | undefined): string {
    return formatCreditorType(value);
  }
}